import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {injectIntl} from 'react-intl';

import {List, ListItem} from 'material-ui/List';

import {Container} from 'flux/utils'
import AgrStore from './data/AgrStore'
import AgrActions from './data/AgrActions'

import ReactMarkdown from 'react-markdown'

class AgreementView extends Component {

  static getStores() {
    return [AgrStore];
  }

  static calculateState(prevState) {
    var state = AgrStore.getState().toObject()

    var fromApp = false
    if (state.hash && state.hash.channel && state.hash.channel.indexOf("_app") !== -1) {
      fromApp = true
    }

    var result = {
      agreement: state.activeAgreement,
      saving: state.saving,
      fromApp: fromApp
    }

    return result
  }

  render() {
    var markdownProps = {}
    if (this.state.fromApp) {
      markdownProps = {
        disallowedTypes: ["link"],
        unwrapDisallowed: true
      }
    }
    var agr = this.state.agreement

    if (agr === null) {
      return null
    }

    var fullText = <div
      class="legal-markdown"
      style={{
        padding: '16px 56px 16px 16px'
      }}
      dangerouslySetInnerHTML={{
        __html: agr.text
      }}/>

    fullText = <ReactMarkdown {...markdownProps} className="legal-markdown" source={agr.text}/>

    return <div>
      <List>
        <ListItem
          disabled={true}
          innerDivStyle={{
            lineHeight: 'default'
          }}>
          <h1>{agr.title}</h1>
        </ListItem>
        <ListItem key="q1" disabled={true}><ReactMarkdown {...markdownProps} source={agr.description}/></ListItem>
        <ListItem
          key="q2"
          onClick={() => {
            this.setState({
              open: !this.state.open
            })
          }}
          initiallyOpen={this.state.open}
          primaryTogglesNestedList={true}
          nestedItems={[fullText]}>{this.props.intl.formatMessage({id: "agreements.text.full"})}</ListItem>
      </List>

      <RaisedButton
        labelStyle={{
          fontFamily: 'Catamaran SemiBold'
        }}
        style={{
          boxShadow: 'default',
          float: 'right',
          marginRight: '16px',
          marginBottom: '16px'

        }}
        disabled={this.state.saving}
        label={this.props.intl.formatMessage({id: "agreements.agree"})}
        primary={true}
        onClick={() => AgrActions.signAgreement(agr, true)}/>
      <RaisedButton
        disabled={this.state.saving}
        label={this.props.intl.formatMessage({id: "agreements.decline"})}
        primary={true}
        onClick={() => AgrActions.signAgreement(agr, false)}
        labelStyle={{
          fontFamily: 'Catamaran SemiBold'
        }}
        style={{
          fontFamily: 'Catamaran SemiBold',
          boxShadow: 'default',
          float: 'right',
          marginRight: '16px',
          marginBottom: '16px'
        }}/>

    </div>
  }
}
export default injectIntl(Container.create(AgreementView))


// WEBPACK FOOTER //
// ./src/AgreementView.js